import React from 'react'
import heroImg from '../imgs/hero-bg.jpg';
import aboutcircletext from '../imgs/about-video-text.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
function herosec() {
  return (
    <section className='herosec'>
      <div className='container'>
        <div className='row align-items-end'>
          <div className='col-xl-10 col-lg-8 col-md-8 col-12'>
            <div className='strip-heading'>Your Digital Journey Begins Here</div>
            <h1 className='h1-heading text-dark'> Turning Ideas into Creative Digital Solutions</h1>
            <p className='fs-5 text-dark fw-400'>We design and develop custom digital products that capture your brand’s essence. </p>
          </div>
          <div className='col-xl-2 col-lg-4 col-md-4 col-12'>
            <div className='position-relative'>
              <div class="rotate-circle">
                  <div class="spinner">
                      <img className='rounded-5' src={aboutcircletext} alt="About Us 2" />
                  </div>
                  <a class="icon-button">
                      <span class="d-inline-flex justify-content-center align-items-center">
                          <FontAwesomeIcon icon={faPlay} />
                      </span>
                  </a>
              </div>
          </div>
          </div>
        </div>
      </div>
      <img className='w-100 mt-5' src={heroImg} alt="Hero Section Image" />
      
    </section>
  )
}

export default herosec
